module.exports = __webpack_public_path__ + "img/home_pic4.73b3b6ce.png";